import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
import { buildEditorialAlternates, buildEditorialCanonical } from '~/helpers/seo-helpers';
export default {
  name: 'Editorial',
  props: {
    type: {
      type: String,
      default: null
    },
    seo: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    baseURL: 'request/baseURL'
  }), {
    speedcurveConfig() {
      const luxConfig = {
        innerHTML: "LUX = window.LUX || {}; LUX.label = '".concat(this.type, "';")
      };
      return luxConfig;
    },

    canonical() {
      var _ref5;

      const customCanonical = (_ref5 = this.seo) != null ? (_ref5 = _ref5.canonical) != null ? _ref5.url : _ref5 : _ref5;

      if (customCanonical) {
        return {
          rel: 'canonical',
          href: customCanonical
        };
      }

      return buildEditorialCanonical(this.baseURL, this.$route.path);
    },

    alternates() {
      var _ref3, _ref4;

      const customAlternates = (_ref4 = this.seo) != null ? (_ref4 = _ref4.alternates) != null ? (_ref4 = _ref4[0]) != null ? (_ref4 = _ref4.url) != null ? _ref4.url : _ref4 : _ref4 : _ref4 : _ref4;
      const emptyAlternates = ((_ref3 = this.seo) != null ? _ref3.empty_alternates : _ref3) === 'true';

      if (customAlternates) {
        return this.seo.alternates.map(e => ({
          rel: 'alternate',
          hreflang: e.hreflang,
          href: e.url.url
        }));
      }

      if (emptyAlternates) {
        return [];
      }

      if (this.type === 'home') {
        return buildEditorialAlternates(this.baseURL, this.type, false, false, true);
      }

      return buildEditorialAlternates(this.baseURL, this.type, this.$route.params.slug, this.$route.params.alias !== this.type ? this.$route.params.alias : false);
    }

  }),

  head() {
    var _ref, _ref2;

    return {
      script: [this.speedcurveConfig],
      title: this.seo.meta_title ? "".concat(this.seo.meta_title, " | Maisons du Monde") : 'Maisons du Monde',
      link: [this.canonical, ...this.alternates],
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: ((_ref2 = this.seo) != null ? _ref2.meta_robots : _ref2) || 'noodp'
      }, {
        name: 'description',
        content: ((_ref = this.seo) != null ? _ref.meta_description : _ref) || ''
      }]
    };
  },

  render: h => h(null)
};